// extracted by mini-css-extract-plugin
module.exports = {"box":"BorderBox-module--box--3eh3t","row":"BorderBox-module--row--M33L7","text":"BorderBox-module--text--1dHr9"};